var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalaryicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99967 3.34342C8.61896 3.34342 7.49967 4.46271 7.49967 5.84342C7.49967 7.22414 8.61896 8.34342 9.99967 8.34342C11.3804 8.34342 12.4997 7.22414 12.4997 5.84342C12.4997 4.46271 11.3804 3.34342 9.99967 3.34342ZM5.83301 5.84342C5.83301 3.54224 7.69849 1.67676 9.99967 1.67676C12.3009 1.67676 14.1663 3.54224 14.1663 5.84342C14.1663 8.14461 12.3009 10.0101 9.99967 10.0101C7.69849 10.0101 5.83301 8.14461 5.83301 5.84342Z",
    fill: "#21272F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49967 13.3434C6.11896 13.3434 4.99967 14.4627 4.99967 15.8434V17.5101C4.99967 17.9703 4.62658 18.3434 4.16634 18.3434C3.7061 18.3434 3.33301 17.9703 3.33301 17.5101V15.8434C3.33301 13.5422 5.19849 11.6768 7.49967 11.6768H12.4997C14.8009 11.6768 16.6663 13.5422 16.6663 15.8434V17.5101C16.6663 17.9703 16.2932 18.3434 15.833 18.3434C15.3728 18.3434 14.9997 17.9703 14.9997 17.5101V15.8434C14.9997 14.4627 13.8804 13.3434 12.4997 13.3434H7.49967Z",
    fill: "#21272F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalaryicon);
export default __webpack_public_path__ + "static/media/salaryicon.2b9480a21f42900d8e6b768253a74cca.svg";
export { ForwardRef as ReactComponent };